import React, { useState, useEffect } from 'react';
import './Mole.css';

const Mole = ({ holeIndex, isActive, characterTypes, characterType }) => {
  const [currentCharacterType, setCurrentCharacterType] = useState('udang1');
  const [isWhacked, setIsWhacked] = useState(false);

  useEffect(() => {
    if (isActive && characterType) {
      // Use the character type passed from parent
      setCurrentCharacterType(characterType);
      setIsWhacked(false);
    } else if (!isActive) {
      // Reset when not active
      setCurrentCharacterType('udang1');
      setIsWhacked(false);
    }
  }, [isActive, characterType, holeIndex]);

  const getCharacterScore = (type) => {
    // SHRIMPERS characters get higher random points (60-100)
    if (type.startsWith('shrimpers')) {
      return Math.floor(Math.random() * 41) + 60;
    }
    // Other characters get normal random points (10-59)
    return Math.floor(Math.random() * 50) + 10;
  };

  return (
    <div 
      className={`mole character ${currentCharacterType} ${isActive ? 'active' : ''} ${isWhacked ? 'whacked' : ''}`}
      id={`mole-${holeIndex}`}
    >
      {/* Character content will be handled by CSS background images */}
    </div>
  );
};

export default Mole;
